import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { testimonials, stats } from '@/mocks/data';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const formUrl = 'http://fydi.cn/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!formUrl) {
      setFormError('表单暂不可用，请稍后再试');
      setFormStatus('error');
      return;
    }

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('website_alt') as string || '').trim();

    if (honeypotValue) {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('website_alt');

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormError('');
        form.reset();
      } else {
        if (typeof serverMsg === 'string' && (serverMsg.toLowerCase().includes('spam') || serverMsg.includes('垃圾'))) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请稍后再试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { name: '首页', path: '/' },
            { name: '关于我们' },
          ]}
        />

        {/* Page Header */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
                关于吃瓜群
              </h1>
              <p className="text-foreground-500 text-base leading-relaxed">
                最懂吃瓜群众的娱乐资讯聚合平台
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div>
                  <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
                    品牌故事
                  </span>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                    让每一个吃瓜群众
                    <br />
                    都能吃到新鲜的瓜
                  </h2>
                  <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
                    <p>
                      吃瓜群成立于2024年初，由一群热爱娱乐八卦、关注社会热点的互联网人共同创立。我们深知"吃瓜"已经成为当代年轻人社交生活中不可或缺的一部分——大家需要一个既快又准、既有料又有趣的平台来满足对各类热门事件的关注。
                    </p>
                    <p>
                      吃瓜群官网聚合了来自全网的海量爆料信息，涵盖明星大瓜、网红塌房、黑料曝光等多个板块。我们坚持"快、准、全"的内容原则，确保每一位吃瓜群众都能第一时间获取最新、最热的瓜。
                    </p>
                    <p>
                      除了内容聚合，吃瓜群还致力于打造吃瓜群众聚集地。通过QQ吃瓜群、吃瓜群APP等多渠道入口，让全国各地的瓜友们能够聚在一起交流讨论，分享自己的独家爆料。
                    </p>
                    <p>
                      目前，吃瓜群已拥有超过320万注册用户，日均活跃用户超过68万，累计内容超过1.5万条。我们正在成为中文互联网上最具影响力的吃瓜平台之一。
                    </p>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden h-[350px] md:h-[450px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20warm%20lighting%2C%20team%20collaboration%20atmosphere%2C%20large%20screens%20displaying%20social%20media%20content%2C%20cozy%20contemporary%20interior%20design%2C%20plants%20and%20natural%20elements%2C%20creative%20workspace%20vibe%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20editorial%20photography%20style&width=900&height=700&seq=chigua-about-story&orientation=portrait"
                    alt="吃瓜群团队办公环境"
                    className="w-full h-full object-cover"
                    loading="lazy"
                    title="吃瓜群团队办公环境"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-14 md:py-20 bg-foreground-950">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-2">
                  吃瓜群的成长数据
                </h2>
                <p className="text-foreground-400 text-sm">每一个数字背后，都是瓜友们的信任</p>
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                {[
                  { value: stats.totalArticles.toLocaleString(), label: '累计爆料', suffix: '+' },
                  { value: (stats.dailyVisitors / 10000).toFixed(0), label: '日活用户', suffix: '万+' },
                  { value: (stats.registeredUsers / 10000).toFixed(0), label: '注册用户', suffix: '万+' },
                  { value: (stats.totalComments / 10000).toFixed(0), label: '累计互动', suffix: '万+' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">
                      {stat.value}
                      <span className="text-primary-400">{stat.suffix}</span>
                    </div>
                    <div className="text-foreground-400 text-sm">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* User Reputation */}
        <section id="reputation" className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-2">
                  用户口碑
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  吃瓜群众真实评价
                </h2>
                <p className="text-foreground-500 text-sm">来自各大平台用户的真实反馈</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t) => (
                  <div key={t.id} className="rounded-lg bg-background-50 border border-background-200/70 p-6">
                    <div className="flex items-center gap-1 mb-4">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                      &ldquo;{t.content}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover"
                        loading="lazy"
                      />
                      <div>
                        <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                        <div className="text-xs text-foreground-400">{t.platform} 用户</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-2">
                  常见问题
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  关于吃瓜群的常见疑问
                </h2>
              </div>

              <div className="space-y-4">
                {[
                  {
                    q: '吃瓜群的信息来源可靠吗？',
                    a: '吃瓜群的内容来自全网多个渠道的聚合整理，包括社交媒体爆料、媒体报道、用户投稿等。我们会对信息进行多方交叉验证后再发布，但对于未经官方证实的爆料信息，我们会在文中标注"据传""网传"等字样，提醒读者理性看待。',
                  },
                  {
                    q: '如何在吃瓜群投稿爆料？',
                    a: '你可以通过吃瓜群APP内的"爆料投稿"功能提交你的独家消息。我们的编辑团队会在24小时内审核，审核通过后的爆料将被发布到对应分类频道。你也可以通过本页下方的联系表单或发送邮件至tips@fydi.cn进行投稿。',
                  },
                  {
                    q: '吃瓜群APP在哪里下载？',
                    a: 'iOS用户可以在App Store搜索"吃瓜群"下载；Android用户请访问吃瓜群官网（fydi.cn）首页扫描二维码下载APK安装包。请认准官方渠道下载，谨防山寨APP。',
                  },
                  {
                    q: 'QQ吃瓜群号在哪里获取？',
                    a: '最新的QQ吃瓜群号会在吃瓜群官网的"吃瓜路线"频道定期更新。你也可以关注我们的官方微博和微信公众号，获取最新的吃瓜群入口信息。',
                  },
                  {
                    q: '吃瓜群的内容是否收费？',
                    a: '吃瓜群目前所有内容全部免费开放，不吃独瓜，快乐共享！我们坚持做免费、开放的吃瓜平台，让每一位吃瓜群众都能尽情享受吃瓜的乐趣。',
                  },
                ].map((faq, idx) => (
                  <details key={idx} className="group rounded-lg bg-background-100 border border-background-200/70">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                      <span className="font-heading text-sm font-semibold text-foreground-950 pr-4">{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section id="contact" className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-2">
                  联系我们
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  欢迎随时联系
                </h2>
                <p className="text-foreground-500 text-sm">
                  有任何问题、建议或合作意向，请通过下方表单联系我们
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
                id="contact-form"
               
                className="rounded-lg bg-background-50 border border-background-200/70 p-6 md:p-8"
              >
                <div className="space-y-5">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      您的姓名
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      电子邮箱
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      主题
                    </label>
                    <input
                      type="text"
                      id="contact-subject"
                      name="subject"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请选择或输入主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言内容
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>

                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />

                  <button
                    type="submit"
                    className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    提交留言
                  </button>

                  {formStatus === 'success' && (
                    <div className="text-center text-sm text-green-600 bg-green-50 rounded-md py-2.5 px-4">
                      感谢您的留言，我们会尽快回复！
                    </div>
                  )}
                  {formStatus === 'error' && formError && (
                    <div className="text-center text-sm text-red-600 bg-red-50 rounded-md py-2.5 px-4">
                      {formError}
                    </div>
                  )}
                </div>
              </form>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5 text-center">
                {[
                  { icon: 'ri-mail-line', title: '电子邮箱', content: 'hello@fydi.cn' },
                  { icon: 'ri-wechat-line', title: '微信公众号', content: '吃瓜群官方' },
                  { icon: 'ri-weibo-line', title: '官方微博', content: '@吃瓜群官网' },
                ].map((item) => (
                  <div key={item.title} className="rounded-lg bg-background-50 border border-background-200/70 p-5">
                    <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center">
                      <i className={`${item.icon} text-primary-600 text-lg`}></i>
                    </div>
                    <div className="text-xs font-semibold text-foreground-700 mb-1">{item.title}</div>
                    <div className="text-xs text-foreground-500">{item.content}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于吃瓜群 - 吃瓜群众免费吃瓜与在线爆料平台',
            description: '吃瓜群官网品牌介绍、用户口碑与联系方式。了解吃瓜群的发展历程、核心数据以及联系方式。',
            url: 'http://fydi.cn/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜群',
              url: 'http://fydi.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://fydi.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '吃瓜群的信息来源可靠吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜群的内容来自全网多个渠道的聚合整理，包括社交媒体爆料、媒体报道、用户投稿等。我们会对信息进行多方交叉验证后再发布，但对于未经官方证实的爆料信息，我们会在文中标注"据传""网传"等字样，提醒读者理性看待。',
                },
              },
              {
                '@type': 'Question',
                name: '如何在吃瓜群投稿爆料？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '你可以通过吃瓜群APP内的"爆料投稿"功能提交你的独家消息。我们的编辑团队会在24小时内审核，审核通过后的爆料将被发布到对应分类频道。你也可以通过联系表单或发送邮件至tips@fydi.cn进行投稿。',
                },
              },
              {
                '@type': 'Question',
                name: '吃瓜群APP在哪里下载？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'iOS用户可以在App Store搜索"吃瓜群"下载；Android用户请访问吃瓜群官网（fydi.cn）首页扫描二维码下载APK安装包。请认准官方渠道下载，谨防山寨APP。',
                },
              },
              {
                '@type': 'Question',
                name: 'QQ吃瓜群号在哪里获取？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '最新的QQ吃瓜群号会在吃瓜群官网的"吃瓜路线"频道定期更新。你也可以关注我们的官方微博和微信公众号，获取最新的吃瓜群入口信息。',
                },
              },
              {
                '@type': 'Question',
                name: '吃瓜群的内容是否收费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜群目前所有内容全部免费开放，不吃独瓜，快乐共享！我们坚持做免费、开放的吃瓜平台，让每一位吃瓜群众都能尽情享受吃瓜的乐趣。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}